import { useQuery } from '@apollo/client'
import { getFile as getFileGql } from 'src/graphql/queries/getFile.gql'

const useFile = (variables, options = {}) => {
   const { data, error, networkStatus, refetch, loading } = useQuery(getFileGql, {
      variables,
      fetchPolicy: 'cache-and-network',
      ...options
   })

   return {
      file: data?.file,
      error,
      loading,
      networkStatus,
      refetch
   }
}

export default useFile
